const selectDialogConfig = (state = { dialogReducer: [] }) =>
  state.dialogReducer.length > 0 ? state.dialogReducer[0] : undefined;

export default selectDialogConfig;
